import { Factory } from 'rosie';
import './lib/uuid';

Factory.define('SelectedKbItem').extend('Uuid');

Factory.define('SelectedKbItemWithDefaults')
  .extend('SelectedKbItem')
  .attr('item', () => Factory.attributes('SnippetWithDefaults', { id: 'some-kb-item-id' }));



// WEBPACK FOOTER //
// ./factories/selected_kb_item.js